import * as yup from 'yup'

export const adminSearchUserSchema = yup
  .object({
    query: yup.string().required(),
  })
  .required()
